module.exports = __webpack_public_path__ + "static/dashbid-fb692bed86b64b5f4a1f88b2a64adf6a.png";